export const CMS_CONTENT_RESPONSE = [
  {
    imageTitle: 'Campinas',
    imageAltText: 'Campinas',
    imageSource:
      '/documents/20124/1563060/imb_original_campinas.jpg/34245685-b36f-c8c7-bbbe-481587a329f6?t=1657334498259',
    imageList: [
      {
        imageWidth: '264',
        imageFile:
          '/documents/20124/1563060/imb_vitrine_campinas.png/587805fb-9ec9-abfd-dec0-e46ecd7358a2?t=1658535057638',
      },
    ],
    friendlyUrlPath: 'imb_campinas',
    categories: ['sao_paulo', 'campinas', 'vcp'],
  },
];
